import { useEffect, useState } from "react";
import fondo from "./images/fondo.jpg";
import textura from "./images/textura.webp";
import cerveza from "./images/cerveza.png";
import hamburguesa from "./images/hamburguesa.png";
import datos from "./datos";
import CategoriaBoton from "./components/CategoriaBoton";
import ProductoLista from "./components/ProductoLista";
import ScrollButton from "./components/ScrollButton";

function App() {
  const [productos, setProductos] = useState([]);
  const [categoria, setCategoria] = useState("Bebestibles");
  const [isBackgroundLoaded, setBackgroundLoaded] = useState(false); // Estado para controlar la carga de la imagen de fondo

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setBackgroundLoaded(true);
    };
    img.src = fondo; // Asigna la URL de la imagen de fondo

    fetch("https://civico.cl/menuRBM/")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => setProductos(data))
      .catch((error) => setProductos(datos));
  }, []);

  const productosPorCategoria = productos.reduce(
    (acc, producto) => {
      const key = producto.superfamilia === "Bebestible" ? "bebestibles" : "comidas";
      const familia = producto.nombre_familia;
      if (!acc[key][familia]) {
        acc[key][familia] = [];
      }
      acc[key][familia].push(producto);
      return acc;
    },
    { bebestibles: {}, comidas: {} }
  );

  return (
    <div className="flex justify-center text-gray-300 md:p-1"
    >
     
      <div className="relative min-h-screen w-[700px] bg-[#7fb6c0] md:rounded-lg shadow-md"
   

      >
         <div className="absolute inset-0 top-0 h-screen z-10"
           style={{ backgroundImage: `url(${textura})` , opacity: "0.12"}}
        >

        </div>
        {/* Loader mientras se carga la imagen de fondo */}
        {!isBackgroundLoaded && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-20 w-20"></div>
          </div>
        )}

        {/* Contenido principal */}
        {isBackgroundLoaded && (
           <div
           className="relative flex w-full justify-center items-center h-[900px] bg-no-repeat bg-center bg-cover"
           style={{ backgroundImage: `url(${fondo})`} }
         >
           <div
             className="absolute inset-0 bg-gradient-to-b from-[#99cdd600] to-[#7fb6c0ff]"
           ></div>
           <div className="flex justify-center gap-[50px] sm:gap-10 md:gap-10 lg:gap-10 xl:gap-10 w-full py-8 md:py-[80px] translate-y-[-70px] z-30">
             <CategoriaBoton
               categoria="Bebestibles"
               icono={cerveza}
               activeCategoria={categoria}
               onClick={() => setCategoria("Bebestibles")}
             />
             <CategoriaBoton
               categoria="Comidas"
               icono={hamburguesa}
               activeCategoria={categoria}
               onClick={() => setCategoria("Comidas")}
             />
           </div>
         </div>
        )}

        {/* Contenido de productos */}
        {isBackgroundLoaded && (
          <div className="px-4 mb-[100px]  translate-y-[-400px]">
            <ProductoLista
              productosPorFamilia={productosPorCategoria[categoria.toLowerCase()]}
              categoria={categoria}
            />
          </div>
        )}

        <ScrollButton />
      </div>
    </div>
  );
}

export default App;
